
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {LegalDocumentGroup} from './LegalDocumentGroup';
import {FieldModelLegalDocumentGroup} from './LegalDocumentGroup';

/**
 * LegalDocumentGroupCreateResult struct
 */
class LegalDocumentGroupCreateResult {
  /**
   * Initialize struct
   * @param {!LegalDocumentGroup=} group
   * @constructor
   */
  constructor (group = new LegalDocumentGroup()) {
    this.Group = group
  }

  /**
   * Copy struct (shallow copy)
   * @this {!LegalDocumentGroupCreateResult}
   * @param {!LegalDocumentGroupCreateResult} other Other struct
   * @returns {!LegalDocumentGroupCreateResult} This struct
   */
  copy (other) {
    if (other.Group != null) {
      this.Group = LegalDocumentGroup.fromObject(other.Group)
    } else {
      this.Group = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!LegalDocumentGroupCreateResult}
   * @returns {!LegalDocumentGroupCreateResult} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new LegalDocumentGroupCreateResultModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new LegalDocumentGroupCreateResultModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!LegalDocumentGroupCreateResult}
   * @param {!LegalDocumentGroupCreateResult} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LegalDocumentGroupCreateResult)) {
      throw new TypeError('Instance of LegalDocumentGroupCreateResult is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!LegalDocumentGroupCreateResult}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Group: ((this.Group != null) ? this.Group : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return LegalDocumentGroupCreateResult.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!LegalDocumentGroupCreateResult} other Object value
   * @returns {!LegalDocumentGroupCreateResult} Created struct
   */
  static fromObject (other) {
    return new LegalDocumentGroupCreateResult().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!LegalDocumentGroupCreateResult}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return LegalDocumentGroupCreateResult.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!LegalDocumentGroupCreateResult}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 15011
  }
}

export { LegalDocumentGroupCreateResult };

/**
 * Fast Binary Encoding LegalDocumentGroupCreateResult field model
 */
class FieldModelLegalDocumentGroupCreateResult extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Group = new FieldModelLegalDocumentGroup(buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Group.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Group.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLegalDocumentGroupCreateResult.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 15011
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Group.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Group.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Group.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!LegalDocumentGroupCreateResult} fbeValue Default value, defaults is new LegalDocumentGroupCreateResult()
   * @returns {!LegalDocumentGroupCreateResult} LegalDocumentGroupCreateResult value
   */
  get (fbeValue = new LegalDocumentGroupCreateResult()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!LegalDocumentGroupCreateResult} fbeValue LegalDocumentGroupCreateResult value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Group.fbeSize) <= fbeStructSize) {
      fbeValue.Group = this.Group.get()
    } else {
      fbeValue.Group = new LegalDocumentGroup()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Group.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {!LegalDocumentGroupCreateResult} fbeValue LegalDocumentGroupCreateResult value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLegalDocumentGroupCreateResult}
   * @param {LegalDocumentGroupCreateResult} fbeValue LegalDocumentGroupCreateResult value
   */
  setFields (fbeValue) {
    this.Group.set(fbeValue.Group)
  }
}

export { FieldModelLegalDocumentGroupCreateResult };

/**
 * Fast Binary Encoding LegalDocumentGroupCreateResult model
 */
class LegalDocumentGroupCreateResultModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLegalDocumentGroupCreateResult(this.buffer, 4)
  }

  /**
   * Get the LegalDocumentGroupCreateResult model
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!FieldModelLegalDocumentGroupCreateResult} model LegalDocumentGroupCreateResult model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return LegalDocumentGroupCreateResultModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLegalDocumentGroupCreateResult.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!LegalDocumentGroupCreateResultModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!LegalDocumentGroupCreateResultModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!LegalDocumentGroupCreateResultModel}
   * @param {!LegalDocumentGroupCreateResult} value LegalDocumentGroupCreateResult value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!LegalDocumentGroupCreateResultModel}
   * @param {!LegalDocumentGroupCreateResult} value LegalDocumentGroupCreateResult value, defaults is new LegalDocumentGroupCreateResult()
   * @return {!object} Deserialized LegalDocumentGroupCreateResult value and its size
   */
  deserialize (value = new LegalDocumentGroupCreateResult()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new LegalDocumentGroupCreateResult(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new LegalDocumentGroupCreateResult(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!LegalDocumentGroupCreateResultModel}
   * @param {!number} prev Previous LegalDocumentGroupCreateResult model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { LegalDocumentGroupCreateResultModel };
